module.exports = __webpack_public_path__ + "img/percent_promo_icon.6ba5a50f.svg";